import { Screen } from './utils/auth';

/**
 * The folder the app is served from, set per environment in .env.<mode>.
 *
 * <p>Live and testing builds sit under a sub-folder on a shared web server
 * (/mobile-shop/, /testmobileshop/), so the router has to be told about it or every
 * link below the first page 404s. Empty when the app owns its whole domain.
 */
export const rootBaseName = import.meta.env.VITE_BASE_PATH || '';

export const routes = {
  dashboard: '/dashboard',
  billing: '/billing',
  purchase: '/purchase',
  bills: '/bills',
  outstanding: '/outstanding',
  products: '/products',
  masters: '/masters',
  reports: '/reports',
  settings: '/settings',
};

/** Each menu item names the screen it belongs to, so permissions decide what shows. */
export const menu: { label: string; path: string; screen: Screen }[] = [
  // The dashboard is the owner's screen: it sits under Reports, so a role without
  // reports lands on Billing instead of an empty wall of numbers.
  { label: 'Dashboard', path: routes.dashboard, screen: 'REPORTS' },
  // One entry, not two: Billing is the list of bills, and the New Bill button on it
  // opens the counter screen. A separate "Bills" item showed the same list again.
  { label: 'Billing', path: routes.billing, screen: 'BILLING' },
  { label: 'Purchase', path: routes.purchase, screen: 'PURCHASE' },
  { label: 'Customer Dues', path: routes.outstanding, screen: 'OUTSTANDING' },
  { label: 'Products', path: routes.products, screen: 'MASTERS' },
  { label: 'Reports', path: routes.reports, screen: 'REPORTS' },
  { label: 'Masters', path: routes.masters, screen: 'MASTERS' },
  { label: 'Settings', path: routes.settings, screen: 'SETTINGS' },
];
